module.exports = __webpack_public_path__ + "img/barcelo-pool-6.31b6a168.jpg";